<template>
    <div class="billa-app--gallery--body--grid--box">
        <div class="billa-app--gallery--body--grid--box--image">
            <img :src="`${options.app_url}/${item.folder}/sutazna_fotografia.png`" :alt="item.title">
        </div>

        <div v-if="voteEnabled" class="billa-app--gallery--body--grid--box--vote">
            <div class="billa-app--gallery--body--grid--box--vote--col">
                <span class="billa-app-like" :class="votedToday" @click="vote()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z" fill="#ffffff" />
                    </svg>								  
                </span>
            </div>

            <div class="billa-app--gallery--body--grid--box--vote--col">
                {{ votes }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            options: {
				type: Object
			},
            item: {
                type: Object
            }
        },
        data() {
            return {
                votedToday: this.hasVotedTodayForThisPhoto( this.item.id ) ? 'liked' : 'not-liked',
                voteEnabled: false
            }
        },
        computed: {
            votes() {
                let votes = 'Hlasov'

                if ( this.item.votes === 1 ) votes = 'Hlas'
                if ( [2, 3, 4].includes( this.item.votes ) ) votes = 'Hlasy'

                return this.item.votes + ' ' + votes
            }
        },
        methods: {
            vote() {
                this.hasVotedToday( this.item.id ) 
                    ? alert("Dnes ste už hlasovali!") 
                    : this.recordVote( this.item.id )
            },
            hasVotedToday() {
                const lastVoteDate = localStorage.getItem(`photo_vote_day`)

                if ( lastVoteDate ) {
                    const today = new Date().toLocaleDateString()
                    return today === lastVoteDate
                }

                return false
            },
            hasVotedTodayForThisPhoto( id ) {
                const lastVoteDate = localStorage.getItem(`photo_vote_${id}`)

                if ( lastVoteDate ) {
                    const today = new Date().toLocaleDateString()
                    return today === lastVoteDate
                }

                return false
            },
            recordVote ( id ) {
                const today = new Date().toLocaleDateString()

                axios.put(`${this.options.app_url}/api/resources/${this.item.id}`, this.item)
				.then( response => {
                    this.$emit('updateVotes', response.data.votes)

                    localStorage.setItem(`photo_vote_${id}`, today)
                    localStorage.setItem(`photo_vote_day`, today)

                    this.votedToday = 'liked'

                    alert( response.data.message )
                }).catch( errors => {
                    console.log( errors.response.data )
                })
            }
        },  
    }
</script>